<div
  data-test="CCSVFJTN"
  class="form-group__field form-group__field_append"
  [ngClass]="containerClasses || ''"
>
  <div
    data-test="qjuC1pGN"
    id="my-link"
    *ngIf="showLoadOptionsLink"
    (click)="loadOptionsLinkClick.next(); focus()"
    class="text-orange"
    style="
      position: absolute;
      left: 7px;
      top: calc(100% + 3px);
      text-decoration: underline;
      cursor: pointer;
      font-size: 90%;
    "
  >
    {{ this.loadOptionsLinkText }}
  </div>

  <ng-container *ngIf="!selectedTemplate; else customSelected">
    <input
      class="input dropdown-focus"
      data-test="dd-input"
      [autocomplete]="uuid"
      [hidden]="multiple && !showInput && model?.length"
      #inputElem
      [attr.size]="size || null"
      [ngClass]="inputClasses || ''"
      [class.active]="inputFocused"
      [readonly]="!filter"
      [disabled]="disabled"
      [autofocus]="autofocus"
      [attr.placeholder]="placeholder"
      (input)="onFilter(inputElem?.value)"
      (keydown)="changeChosenByKeyboard($event)"
      (keyup.enter)="inputPressEnter($event)"
      (keydown.tab)="inputTabKeyDown($event)"
      (focus)="resetFilter(); focus($event)"
      (blur)="blur($event)"
      [tabindex]="inputTabIndex"
    />
    <label
      *ngIf="showArrowDown"
      data-test="_542XACM"
      class="form-group__field-append link-light"
    >
      <i data-test="0nmHgFZ3" class="material-icons md-16">keyboard_arrow_down</i>
    </label>
    <div
      data-test="v74uLcmi"
      class="form-group__field-clear"
      *ngIf="canClear && !modelIsEmpty()"
      (click)="$event.stopPropagation(); clearValue()"
    >
      <i data-test="WO3Dz4eD" class="material-icons md-12">close</i>
    </div>
    <div
      data-test="Mx36D5ox"
      class="field-tag"
      (focus)="showInputAndFocus($event)"
      tabindex="0"
      [hidden]="!multiple || showInput || !model?.length"
    >
      <div
        data-test="upQnLg4s"
        class="input input_tags"
        [ngClass]="inputClasses || ''"
        [class.input_disabled]="disabled"
      >
        <div
          data-test="tbS2sPty"
          class="field-tag__item"
          data-label="item"
          *ngIf="multipleValue$ | async | notNull as multipleVal"
        >
          {{ multipleVal.label }}
          <span
            data-test="XUvxl1MT"
            *ngIf="multipleVal.amount"
            class="badge badge_gray ml-1"
          >
            {{ multipleVal.amount }}
          </span>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #customSelected>
    <div data-test="93YsphRw" (click)="toggleFocus()" class="dropdown-focus">
      <div
        data-test="Yz2-LZlx"
        class="form-group__field-clear"
        style="right: 40px"
        *ngIf="canClear && !modelIsEmpty()"
        (click)="$event.stopPropagation(); clearValue()"
      >
        <i data-test="PW74UFgP" class="material-icons md-12">close</i>
      </div>
      <ng-container
        *ngTemplateOutlet="
          selectedTemplate;
          context: { $implicit: chosenOption, value: model }
        "
      ></ng-container>
    </div>
  </ng-template>

  <div
    data-test="IIEQzC-s"
    *ngIf="initialized && (alwaysActive || inputFocused)"
    class="dropdown p-0 show active"
    [class.w-100]="!autoWidth"
    [ngClass]="dropdownClasses || ''"
    [ngStyle]="dropdownStyles || null"
    infiniteScroll
    [infiniteScrollDisabled]="!url || !infiniteScroll"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="50"
    [infiniteScrollContainer]="scrollElem"
    (scrolled)="moreOptions()"
  >
    <!--
      simplebar moved to second level wrapper block due to fix dropdown arrows
    -->
    <div data-test="dld2IWq7" class="dropdown__wrap">
      <div
        data-test="LZ6889A7"
        class="dropdown__scrollbar-wrap w-auto flex-column"
        data-simplebar="init"
      >
        <div data-test="YM_VXyL8" *ngIf="selectedTemplate" class="dropdown__search">
          <!-- (mousedown) for BC -->
          <input
            #inputElem
            [tabindex]="inputTabIndex"
            [hidden]="!filter"
            data-test="t93svhPc"
            class="dropdown__input input input_xs"
            [autocomplete]="uuid"
            [attr.placeholder]="placeholder"
            [ngClass]="inputClasses || ''"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (input)="onFilter(inputElem?.value)"
            (keydown)="changeChosenByKeyboard($event)"
            (keyup.enter)="inputPressEnter($event)"
            (blur)="clearInputValue(); onFilter()"
            (submit)="$event.preventDefault(); $event.stopPropagation()"
          />
        </div>
        <div data-test="_JKthMK2" class="simplebar-scroll-content" #scrollElem>
          <div data-test="XFaWDIWA" class="simplebar-content">
            <div data-test="F6-3J_y4" class="dropdown__menu" #listElem>
              <div data-test="Qky9gRG0" class="text-center" *ngIf="isOptionsLoading">
                <div data-test="ihWFnDPt" class="d-inline-block">
                  <i data-test="P179YQJS" class="loader-spin"></i>
                </div>
              </div>

              <ng-template
                #listItem
                let-option
                let-isEmptyOptionLabel="isEmptyOptionLabel"
              >
                <!-- (mousedown) for BC -->
                <div
                  data-test="XJiUMMk6"
                  class="dropdown__menu-item"
                  [class.active]="isChosenByKeyboard(option)"
                  [class.checked]="
                    highlightChosenOption && isChosen(option, isEmptyOptionLabel)
                  "
                  (mouseenter)="setChosenByHover(option)"
                  (mouseleave)="setChosenByHover(undefined)"
                  (mousedown)="selectValue(option)"
                >
                  <ng-container
                    *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"
                  ></ng-container>
                  <ng-container *ngIf="!optionTemplate">
                    <div data-test="xqkSRHXO" class="dropdown__menu-link">
                      <div data-test="ukU19tYe">
                        {{
                          isEmptyOptionLabel && option === getEmptyOption()
                            ? getEmptyOptionLabel()
                            : getOptionLabel(option)
                        }}
                      </div>

                      <div
                        data-test="a_Yn-W4j"
                        *ngIf="descriptionKey"
                        class="text-nowrap text-truncate"
                        style="font-style: italic; color: #888"
                      >
                        {{ option[descriptionKey]?.trim() }}
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-template>

              <ng-container *ngIf="!groupBy; else optionsGroups">
                <ng-container *ngFor="let option of getOptions(); trackBy: trackBy">
                  <ng-container
                    *ngTemplateOutlet="
                      listItem;
                      context: { $implicit: option, isEmptyOptionLabel: false }
                    "
                  ></ng-container>
                </ng-container>
                <ng-container
                  *ngIf="
                    canSelectEmptyOption && !isOptionsLoading && !getOptions().length
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="
                      listItem;
                      context: {
                        $implicit: getEmptyOption(),
                        isEmptyOptionLabel: true
                      }
                    "
                  ></ng-container>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="_canAdd && getCreateOptions().length">
                <div
                  [hidden]="isAddNewHidden() || !input?.nativeElement?.value"
                  id="top_mark"
                  class="dropdown__menu-item"
                  data-test="dd-add-new"
                  *ngFor="let option of getCreateOptions(); trackBy: trackByCreateOptions"
                  (mousedown)="
                    input?.nativeElement?.value &&
                      addNew(input.nativeElement.value, option.url, option.itemName)
                  "
                >
                  <a data-test="gvpARBVD" class="dropdown__menu-link">
                    <i data-test="9nHrXn4t" class="icon material-icons md-16">add</i>
                    <span data-test="tJMfycVR">
                      Create new {{ option.itemName }}
                      <b data-test="qsXAVME5">{{ input?.nativeElement?.value }}</b>
                    </span>
                  </a>
                </div>
              </ng-container>

              <ng-template #optionsGroups>
                <ng-container *ngFor="let group of groupedOptions; trackBy: trackBy">
                  <div
                    data-test="IXP6mQoj"
                    class="dropdown__menu-group"
                    *ngIf="
                      group.options.length ||
                      (!isAddNewHidden() && !!input?.nativeElement?.value)
                    "
                  >
                    <ng-container *ngIf="group.options.length">
                      <div
                        data-test="6akpJzMM"
                        class="dropdown__menu-group-title font-weight-bold"
                      >
                        {{ group.title }}
                      </div>
                      <div data-test="HufeSpM4" class="dropdown__menu-group-items">
                        <ng-container
                          *ngFor="let option of group.options; trackBy: trackBy"
                        >
                          <ng-container
                            *ngTemplateOutlet="listItem; context: { $implicit: option }"
                          ></ng-container>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="
                    canSelectEmptyOption && !isOptionsLoading && !groupedOptions.length
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="
                      listItem;
                      context: {
                        $implicit: getEmptyOption(),
                        isEmptyOptionLabel: true
                      }
                    "
                  ></ng-container>
                </ng-container>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
